import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../../constants/pages-and-paths';
import {AuthGuardService} from '../../../../guards/auth-guard.service';
import {UserExperiencesComponent} from './user-experiences.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.adminUserExperiences.pageInRouting,
    data: {data: PAGES_AND_PATHS.adminUserExperiences},
    component: UserExperiencesComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./user-experiences.module').then(m => m.UserExperiencesModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserExperiencesRoutingModule { }
